import React, { useState } from "react";
import UserList from "./UserList/UserList";
import UserTypeList from "./UserTypeList/UserTypeList";
import AgentList from "./AgentList/AgentList";




const UserAccount = () => {
  const [activeComponent, setActiveComponent] = useState(localStorage.getItem('UserAccount') || "User List");

  // Array with tab names and corresponding components
  const tabs = [
    { name: "User List", component:  <UserList/>},
    { name: "User Type List", component:  <UserTypeList />},
    { name: "Agent List", component:  <AgentList />},
  ];

  // Find the active tab and its component
  const renderComponent = () => {
    const activeTab = tabs.find(tab => tab.name === activeComponent);
    return activeTab ? activeTab.component : null;
  };

  const changeActiveComponent = (name)=>{
    setActiveComponent(name)
    localStorage.setItem('UserAccount',name);
  }

  return (
    <div className="min-h-screen flex flex-col items-center p-6 pt-14">
      <div style={{zIndex:10}} className="flex flex-col justify-center items-center w-full sticky top-14 bg-[var(--bgColor)]">
      <h1 className="text-xl m-4 font-semibold">User Account</h1>
      <div className="flex gap-2 max-w-100 flex-wrap mb-2">
        {tabs.map(({ name }) => (
          <button
            key={name}
            className={`p-2 rounded-lg text-sm border-b-2 min-w-[100px] ${
              activeComponent === name
                ? "activeBtn text-white"
                : "bg-neutral-50 text-gray-800 hover:bg-blue-100"
            }`}
            onClick={() => {changeActiveComponent(name)}}
          >
            {name}
          </button>
        ))}
      </div>
      </div>

      {renderComponent()}
    </div>
  );
};

export default UserAccount;
